// Module
var code = "<script id=\"wcc-components-wcc-heatmap-views-panel\" type=\"text/template\">\r\n    <!-- ko foreach: viewLinks -->\r\n    <span class=\"wcc-heatmap__views-panel__link\" data-bind=\"click: $component.activateView, text: title, css: { 'wcc-heatmap__views-panel__link--active': isActive }\"></span>\r\n    <!-- /ko -->\r\n</script>";
// Exports
module.exports = code;